

























































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { uniqueId } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  BODY_HEIGHT,
  Col,
  DataTableHeader
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'

export interface AuthorityTableItem {
  isSelected: boolean
  display: string
  displayKana: string
  tag: string
  authorityNo: string
}

export const defaultAuthorityTableItem = (): AuthorityTableItem => ({
  isSelected: false,
  display: '',
  displayKana: '',
  tag: '',
  authorityNo: ''
})

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'display',
        headerText: '表記'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'displayKana',
        headerText: 'カナ'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'authorityId',
        headerText: '典拠ＩＤ'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'authorityNo',
        headerText: '管理番号'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class AuthorityTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  items!: AuthorityTableItem[]

  @Prop({
    type: Number,
    default: BODY_HEIGHT
  })
  height!: number

  get radioName(): string {
    return uniqueId('authority-table')
  }

  get showCols(): Col[] {
    return COLS
  }

  @Emit('select:item')
  onClickTableRow(index: number): number {
    return index
  }
}
